import React from 'react';
import { CobuStack, CobuText } from '@cobu/ui';
import AutoLinkText from '../chat/groupDiscussion/AutoLinkText';
import { Gathering } from '@cobu/types';
import { Strings } from '../../constants/Strings';

interface GroupMember {
  uuid: string;
  user: {
    uuid: string;
    name: string;
    profileImage?: string;
  };
  active: boolean;
}

interface EventDetailInfoProps {
  gathering: Gathering;
  currentMembers: GroupMember[];
}

// Macaroni appends a fixed English suffix to descriptions on event creation
// (see frontends/macaroni GatheringForm). Detect both apostrophe variants and
// swap for the localized version at display time.
const RSVP_SUFFIX_PATTERN = /\n\nPlease RSVP - it helps us plan better! Plus, you['’]ll get reminders\.\s*$/;
const INTEREST_SUFFIX_PATTERN = /\n\nPlease express interest - it helps us plan better! Plus, you['’]ll get reminders\.\s*$/;

const localizeDescription = (description: string): string => {
  const suffix = Strings.get().events.detail.descriptionSuffix;
  if (RSVP_SUFFIX_PATTERN.test(description)) {
    return description.replace(RSVP_SUFFIX_PATTERN, `\n\n${suffix.rsvp}`);
  }
  if (INTEREST_SUFFIX_PATTERN.test(description)) {
    return description.replace(INTEREST_SUFFIX_PATTERN, `\n\n${suffix.expressInterest}`);
  }
  return description;
};

export function EventDetailInfo({
  gathering,
  currentMembers
}: EventDetailInfoProps) {
  const strings = Strings.get();

  return (
    <CobuStack >
      {/* Event Description */}
      {gathering.description && (
        <CobuStack p="$4" mb="$2" elevation={0.2}>
          <CobuText
            variant="heading"
            fos="$4"
            fow="bold"
            col="$cobuDarkBlue"
          >
            {strings.events.detail.labels.about}
          </CobuText>
          <AutoLinkText
            text={localizeDescription(gathering.description)}
            variant="body"
            fontSize="$3"
          />
        </CobuStack>
      )}
    </CobuStack>
  );
}